import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../lib/user-auth';

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="font-serif text-4xl font-bold text-ink">
            Mizan<span className="text-gold">™</span>
          </h1>
          <p className="text-taupe mt-2 text-sm">La couche d'intelligence d'eFactura Suite</p>
        </div>

        <div className="card">
          <h2 className="font-serif text-xl mb-4">Connexion cabinet</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="email">
                Email professionnel
              </label>
              <input
                id="email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="password">
                Mot de passe
              </label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-border rounded px-3 py-2"
              />
            </div>
            {error && (
              <div className="text-sm text-red-800 border border-red-300 bg-red-50 rounded p-2">
                {error}
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? 'Connexion…' : 'Se connecter'}
            </button>
          </form>
        </div>

        <div className="mt-4 text-center text-xs text-taupe">
          Pas de compte ? <Link to="/admin/login" className="text-gold underline">Espace super-admin</Link> pour créer un cabinet.
        </div>
      </div>
    </div>
  );
}
